export default "__VITE_ASSET__Dt5MBV1V__"